import React, { useState } from 'react';
import { Form, Image, Modal, Button } from 'react-bootstrap';
import imgPlaceholder from '../../../assets/images/placeholder/customer-image-placeholder.png';
import './index.css';
import { IoMdAdd } from 'react-icons/io';
import { IoCreate, IoTrash } from 'react-icons/io5';
import StatesCities from "../../../assets/json/states-and-districts.json";

function AssociateForm({ data, setData, imageSource, setImageSource, inputError, setInputError }) {

  const [stateCities, setStateCities] = useState(null);
  const [bankIndex, setBankIndex] = useState(null);
  const [bankDetails, setBankDetails] = useState({
    accountNumber: '',
    reAccountNumber: '',
    ifsc: '',
    bankBranch: '',
    accountHolderName: '',
    upi: ''
  });
  const [showBankModal, setShowBankModal] = useState(false);
  const [bankInputError, setBankInputError] = useState(null);

  const resetBankForm = () => {
    setBankDetails({
      accountNumber: '',
      reAccountNumber: '',
      ifsc: '',
      bankBranch: '',
      accountHolderName: '',
      upi: ''
    });
    setBankIndex(null);
  }

  const handleClose = () => {
    resetBankForm();
    setBankInputError(null);
    setShowBankModal(false);
  };
  const handleShow = () => setShowBankModal(true);

  function getStateCities(state) {
    const filteredCitiesByState = StatesCities && StatesCities.find(val => val.state === state).districts;

    if (filteredCitiesByState) {
      setStateCities(filteredCitiesByState);
    }
  }

  const handleSaveBankDetails = () => {
    const { accountHolderName, accountNumber, reAccountNumber, ifsc, bankBranch } = bankDetails;

    if (!accountNumber) {
      setBankInputError({ ...inputError, accountNumber: 'This field is required.' });
    } else if (!reAccountNumber) {
      setBankInputError({ ...inputError, reAccountNumber: 'This field is required.' });
    } else if (accountNumber && reAccountNumber && accountNumber !== reAccountNumber) {
      setBankInputError({ ...inputError, reAccountNumber: 'Account number does not match.' });
    } else if (!ifsc) {
      setBankInputError({ ...inputError, ifsc: 'This field is required.' });
    } else if (!bankBranch) {
      setBankInputError({ ...inputError, bankBranch: 'This field is required.' });
    } else if (!accountHolderName) {
      setBankInputError({ ...inputError, accountHolderName: 'This field is required.' });
    } else {
      const tempArray = [...data.bankDetails];

      if (bankIndex !== null) {
        tempArray[bankIndex] = bankDetails;

        setData({
          ...data,
          bankDetails: tempArray
        });
      } else {
        tempArray.push(bankDetails);

        setData({
          ...data,
          bankDetails: tempArray
        });
      }

      handleClose();
      resetBankForm();
    }
  }

  function handleUpdateBankDetails(item, index) {
    if (item) {
      setBankIndex(index);
      setBankDetails(item);
      setShowBankModal(true);
    }
  }

  function handleDeleteBankDetails(index) {
    const tempArray = [...data.bankDetails];

    if (index > -1) {
      tempArray.splice(index, 1);
    }

    setData({
      ...data,
      bankDetails: tempArray
    });
  }

  return (
    <Form>
      <div className='row'>
        <div className='col-lg-2 col-md-2 -col-12'>
          <div className='py-3'>
            <Form.Group controlId="formAssociatePhoto" className="mb-3">
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(event) => {
                  setImageSource(event.target.files[0]);
                }}
                hidden
              />
              {
                data && data.photo && !imageSource ?
                  <Image src={data.photo} className='cursor-pointer' fluid thumbnail rounded onClick={() => document.getElementById('formAssociatePhoto').click()} />
                  :
                  <Image src={imageSource ? URL.createObjectURL(imageSource) : imgPlaceholder} className='cursor-pointer' fluid thumbnail rounded onClick={() => document.getElementById('formAssociatePhoto').click()} />
              }
            </Form.Group>
          </div>
        </div>
        <div className='col-lg-10 col-md-10 col-12'>
          <div className='form-wrapper py-3'>
            <div className='form-head mt-0'>
              <h5>Basic Details</h5>
            </div>
            <div className='row'>
              <div className='col-lg-12 col-12'>
                <Form.Group className="mb-3" controlId="formAssociateName">
                  <Form.Label>Associate Name *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter associate name"
                    onChange={(e) => {
                      setData({
                        ...data,
                        name: e.target.value,
                      });
                      setInputError({ ...inputError, name: '' })
                    }}
                    className={inputError && inputError.name ? 'border-danger' : null}
                    value={data.name}
                    isInvalid={inputError && inputError.name}
                  />
                  <Form.Control.Feedback type="invalid">{inputError && inputError.name}</Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className='col-lg-4 col-12'>
                <Form.Group className="mb-3" controlId="formFatherHusband">
                  <Form.Label>Father/Husband Name *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter father/husband name"
                    onChange={(e) => {
                      setData({
                        ...data,
                        fatherHusband: e.target.value,
                      });
                      setInputError({ ...inputError, fatherHusband: '' })
                    }}
                    className={inputError && inputError.fatherHusband ? 'border-danger' : null}
                    value={data.fatherHusband}
                    isInvalid={inputError && inputError.fatherHusband}
                  />
                  <Form.Control.Feedback type="invalid">{inputError && inputError.fatherHusband}</Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className='col-lg-4 col-12'>
                <Form.Group className="mb-3" controlId="formGender">
                  <Form.Label>Gender *</Form.Label>
                  <Form.Select
                    onChange={(e) => {
                      setData({
                        ...data,
                        gender: e.target.value,
                      });
                      setInputError({ ...inputError, gender: '' })
                    }}
                    value={data.gender}
                    isInvalid={inputError && inputError.gender}
                  >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">{inputError && inputError.gender}</Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className='col-lg-4 col-12'>
                <Form.Group className="mb-3" controlId="formDob">
                  <Form.Label>Date of Birth *</Form.Label>
                  <Form.Control
                    type="date"
                    onChange={(e) => {
                      setData({
                        ...data,
                        dob: e.target.value,
                      });
                      setInputError({ ...inputError, dob: '' })
                    }}
                    className={inputError && inputError.dob ? 'border-danger' : null}
                    value={data.dob}
                    isInvalid={inputError && inputError.dob}
                  />
                  <Form.Control.Feedback type="invalid">{inputError && inputError.dob}</Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className='col-lg-4 col-12'>
                <Form.Group className="mb-3" controlId="formPanNumber">
                  <Form.Label>Pan Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter pan number"
                    onChange={(e) => {
                      setData({
                        ...data,
                        panNumber: e.target.value,
                      });
                      setInputError({ ...inputError, panNumber: '' })
                    }}
                    className={inputError && inputError.panNumber ? 'border-danger' : null}
                    value={data.panNumber}
                    isInvalid={inputError && inputError.panNumber}
                  />
                  <Form.Control.Feedback type="invalid">{inputError && inputError.panNumber}</Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className='col-lg-4 col-12'>
                <Form.Group className="mb-3" controlId="formAadharNumber">
                  <Form.Label>Aadhar Number *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter aadhar number"
                    onChange={(e) => {
                      setData({
                        ...data,
                        aadharNumber: e.target.value,
                      });
                      setInputError({ ...inputError, aadharNumber: '' })
                    }}
                    className={inputError && inputError.aadharNumber ? 'border-danger' : null}
                    value={data.aadharNumber}
                    isInvalid={inputError && inputError.aadharNumber}
                  />
                  <Form.Control.Feedback type="invalid">{inputError && inputError.aadharNumber}</Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className='col-lg-4 col-12'>
                <Form.Group className="mb-3" controlId="formPhoneNumber">
                  <Form.Label>Phone Number *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter phone number"
                    onChange={(e) => {
                      setData({
                        ...data,
                        phoneNumber: e.target.value,
                      });
                      setInputError({ ...inputError, phoneNumber: '' })
                    }}
                    className={inputError && inputError.phoneNumber ? 'border-danger' : null}
                    value={data.phoneNumber}
                    isInvalid={inputError && inputError.phoneNumber}
                  />
                  <Form.Control.Feedback type="invalid">{inputError && inputError.email}</Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className='col-lg-4 col-12'>
                <Form.Group className="mb-3" controlId="formAltNumber">
                  <Form.Label>Alternate Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Alternate Number"
                    onChange={(e) => {
                      setData({
                        ...data,
                        alternatePhoneNumber: e.target.value,
                      });
                      setInputError({ ...inputError, alternatePhoneNumber: '' })
                    }}
                    className={inputError && inputError.alternatePhoneNumber ? 'border-danger' : null}
                    value={data.alternatePhoneNumber}
                    isInvalid={inputError && inputError.alternatePhoneNumber}
                  />
                  <Form.Control.Feedback type="invalid">{inputError && inputError.alternatePhoneNumber}</Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className='col-lg-8 col-12'>
                <Form.Group className="mb-3" controlId="formAssociateEmail">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter email address"
                    onChange={(e) => {
                      setData({
                        ...data,
                        email: e.target.value,
                      });
                      setInputError({ ...inputError, email: '' })
                    }}
                    className={inputError && inputError.email ? 'border-danger' : null}
                    value={data.email}
                    isInvalid={inputError && inputError.email}
                  />
                  <Form.Control.Feedback type="invalid">{inputError && inputError.email}</Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>

            <div className='form-head'>
              <h5>Contact Details</h5>
            </div>

            <div className='row'>
              <div className='col-lg-6 col-12'>
                <Form.Group className="mb-3" controlId="formAddress">
                  <Form.Label>Address *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter address"
                    onChange={(e) => {
                      setData({
                        ...data,
                        address: e.target.value,
                      });
                      setInputError({ ...inputError, address: '' })
                    }}
                    className={inputError && inputError.address ? 'border-danger' : null}
                    value={data.address}
                    isInvalid={inputError && inputError.address}
                  />
                  <Form.Control.Feedback type="invalid">{inputError && inputError.address}</Form.Control.Feedback>
                </Form.Group>
              </div>

              <div className='col-md-6 col-12'>
                <Form.Group className="mb-3" controlId="state">
                  <Form.Label>State *</Form.Label>
                  <Form.Select
                    onChange={(e) => {
                      setData({
                        ...data,
                        state: e.target.value,
                      });
                      setInputError({ ...inputError, state: '' })
                      getStateCities(e.target.value);
                    }}
                    value={data.state}
                    isInvalid={inputError && inputError.state}
                  >
                    <option>Select</option>
                    {
                      StatesCities && StatesCities.map((item, index) => {
                        return (
                          <option key={index} value={item.state}>{item.state}</option>
                        )
                      })
                    }
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">{inputError && inputError.state}</Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className='col-md-6 col-12'>
                <Form.Group className="mb-3" controlId="city">
                  <Form.Label>City *</Form.Label>
                  <Form.Select
                    onChange={(e) => {
                      setData({
                        ...data,
                        city: e.target.value,
                      });
                      setInputError({ ...inputError, city: '' })
                    }}
                    value={data.city}
                    isInvalid={inputError && inputError.city}
                  >
                    <option value="sqft">Select</option>
                    {
                      stateCities && stateCities.map((city, index) => {
                        return (
                          <option key={index} value={city}>{city}</option>
                        )
                      })
                    }
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">{inputError && inputError.city}</Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className='col-lg-6 col-12'>
                <Form.Group className="mb-3" controlId="formPincode">
                  <Form.Label>Pincode *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter pincode"
                    onChange={(e) => {
                      setData({
                        ...data,
                        pincode: e.target.value,
                      });
                      setInputError({ ...inputError, pincode: '' })
                    }}
                    className={inputError && inputError.pincode ? 'border-danger' : null}
                    value={data.pincode}
                    isInvalid={inputError && inputError.pincode}
                  />
                  <Form.Control.Feedback type="invalid">{inputError && inputError.pincode}</Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>
            <div className='form-head'>
              <div className='row'>
                <div className='col-8'>
                  <h5 className='mb-0'>Bank Details</h5>
                </div>
                <div className='col-4 d-flex justify-content-end'>
                  {
                    data && data.bankDetails && data.bankDetails.length > 0 ?
                      <Button
                        variant='outline-primary'
                        className='shadow-none py-2'
                        onClick={handleShow}
                      >
                        <div className='d-flex align-items-center justify-content-center'>
                          <IoMdAdd size={20} />
                          <span className='mb-0 ms-2'>Add New</span>
                        </div>
                      </Button>
                      :
                      null
                  }
                </div>
              </div>
            </div>

            <div className='bank-table mb-5'>
              <table className='table'>
                <thead className='table-head sticky-top'>
                  <tr>
                    <th>#</th>
                    <th>Account Number</th>
                    <th>Account Holder</th>
                    <th>IFSC Code</th>
                    <th>Bank Name</th>
                    <th>UPI ID</th>
                    <th></th>
                  </tr>
                </thead>
                {
                  data && data.bankDetails && data.bankDetails.length > 0 ?
                    <tbody>
                      {
                        data.bankDetails.map((bk_item, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{bk_item.accountNumber}</td>
                              <td>{bk_item.accountHolderName}</td>
                              <td>{bk_item.ifsc}</td>
                              <td>{bk_item.bankBranch}</td>
                              <td>{bk_item.upi}</td>
                              <td className='d-flex align-items-center justify-content-center'>
                                <Button
                                  variant='outline-primary'
                                  className='me-1 border-0'
                                  size='sm'
                                  onClick={() => handleUpdateBankDetails(bk_item, index)}
                                >
                                  <IoCreate size={16} />
                                </Button>
                                <Button
                                  variant='outline-danger'
                                  className='ms-1 border-0'
                                  size='sm'
                                  onClick={() => handleDeleteBankDetails(index)}
                                >
                                  <IoTrash size={16} />
                                </Button>
                              </td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                    :
                    null
                }
              </table>
              {
                data && data.bankDetails && data.bankDetails.length > 0 ?
                  null
                  :
                  <Button
                    variant='white'
                    className='w-100 py-5 border-long-dashed rounded border-0 shadow-none'
                    onClick={handleShow}
                  >
                    <div className='d-flex align-items-center justify-content-center'>
                      <IoMdAdd size={20} color='var(--bs-primary)' />
                      <h6 className='mb-0 ms-2 text-primary'>Add New Bank</h6>
                    </div>
                  </Button>
              }
            </div>
          </div>
        </div>
      </div>

      {/* ADD BANK MODAL */}
      <Modal
        show={showBankModal}
        onHide={handleClose}
        backdrop="static"
        size='lg'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Bank Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-lg-6 col-12'>
              <Form.Group className="mb-3" controlId="accountNumber">
                <Form.Label>Account Number *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g - 123456789054321"
                  onChange={(e) => {
                    setBankDetails({
                      ...bankDetails,
                      accountNumber: e.target.value,
                    });
                    setBankInputError({ ...bankInputError, accountNumber: '' })
                  }}
                  className={bankInputError && bankInputError.accountNumber ? 'border-danger' : null}
                  value={bankDetails.accountNumber}
                  isInvalid={bankInputError && bankInputError.accountNumber}
                />
                <Form.Control.Feedback type="invalid">{bankInputError && bankInputError.accountNumber}</Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className='col-lg-6 col-12'>
              <Form.Group className="mb-3" controlId="reAccountNumber">
                <Form.Label>Re-Enter Account Number *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g - 123456789054321"
                  onChange={(e) => {
                    setBankDetails({
                      ...bankDetails,
                      reAccountNumber: e.target.value,
                    });
                    setBankInputError({ ...bankInputError, reAccountNumber: '' })
                  }}
                  className={bankInputError && bankInputError.reAccountNumber ? 'border-danger' : null}
                  value={bankDetails.reAccountNumber}
                  isInvalid={bankInputError && bankInputError.reAccountNumber}
                />
                <Form.Control.Feedback type="invalid">{bankInputError && bankInputError.reAccountNumber}</Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className='col-lg-6 col-12'>
              <Form.Group className="mb-3" controlId="ifsc">
                <Form.Label>IFSC Code *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g - AXIS000123"
                  onChange={(e) => {
                    setBankDetails({
                      ...bankDetails,
                      ifsc: e.target.value.toUpperCase(),
                    });
                    setBankInputError({ ...bankInputError, ifsc: '' })
                  }}
                  className={bankInputError && bankInputError.ifsc ? 'border-danger' : null}
                  value={bankDetails.ifsc}
                  isInvalid={bankInputError && bankInputError.ifsc}
                />
                <Form.Control.Feedback type="invalid">{bankInputError && bankInputError.ifsc}</Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className='col-lg-6 col-12'>
              <Form.Group className="mb-3" controlId="bankBranch">
                <Form.Label>Bank & Branch Name *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g - Axis Bank, Civil Lines"
                  onChange={(e) => {
                    setBankDetails({
                      ...bankDetails,
                      bankBranch: e.target.value,
                    });
                    setBankInputError({ ...bankInputError, bankBranch: '' })
                  }}
                  className={bankInputError && bankInputError.bankBranch ? 'border-danger' : null}
                  value={bankDetails.bankBranch}
                  isInvalid={bankInputError && bankInputError.bankBranch}
                />
                <Form.Control.Feedback type="invalid">{bankInputError && bankInputError.bankBranch}</Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className='col-lg-6 col-12'>
              <Form.Group className="mb-3" controlId="accountHolderName">
                <Form.Label>Account Holders Name *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g - Jack Sparrow"
                  onChange={(e) => {
                    setBankDetails({
                      ...bankDetails,
                      accountHolderName: e.target.value,
                    });
                    setBankInputError({ ...bankInputError, accountHolderName: '' })
                  }}
                  className={bankInputError && bankInputError.accountHolderName ? 'border-danger' : null}
                  value={bankDetails.accountHolderName}
                  isInvalid={bankInputError && bankInputError.accountHolderName}
                />
                <Form.Control.Feedback type="invalid">{bankInputError && bankInputError.accountHolderName}</Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className='col-lg-6 col-12'>
              <Form.Group className="mb-3" controlId="upi">
                <Form.Label>UPI ID *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g - abc@okaxis"
                  onChange={(e) => {
                    setBankDetails({
                      ...bankDetails,
                      upi: e.target.value,
                    });
                  }}
                  value={bankDetails.upi}
                />
              </Form.Group>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className='justify-content-between'>
          <Button
            variant="outline-dark"
            onClick={handleClose}
            className='px-5 py-2'
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className='px-5 py-2'
            onClick={handleSaveBankDetails}
          >
            {
              bankIndex !== null ?
                'Update'
                :
                'Save'
            }
          </Button>
        </Modal.Footer>
      </Modal>
    </Form >
  );
}

export default AssociateForm;
